/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ResponseChangeUser interface.
 */
export function instanceOfResponseChangeUser(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    return true;
}
export function ResponseChangeUserFromJSON(json) {
    return ResponseChangeUserFromJSONTyped(json, false);
}
export function ResponseChangeUserFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
    };
}
export function ResponseChangeUserToJSON(json) {
    return ResponseChangeUserToJSONTyped(json, false);
}
export function ResponseChangeUserToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
    };
}
